// extracted by mini-css-extract-plugin
export var logo = "_lg-2";
export var logoWrapper = "_lg-1";
export var strip = "_lg-0";